import React from 'react';
import classNames from 'classnames';
import styles from './ContainerBody.module.scss';

export interface ContainerBodyProps {
  children: React.ReactNode;
  className?: string;
}

const ContainerBody: React.FC<ContainerBodyProps> = ({ children, className }) => {
  return <div className={classNames(styles.root, className)}>{children}</div>;
};

export default ContainerBody;
